function getHashParams() {

    var hashParams: any = {};
    var e,
        a = /\+/g,  // Regex for replacing addition symbol with a space
        r = /([^&;=]+)=?([^&;]*)/g,
        d = function (s: string) { return decodeURIComponent(s.replace(a, " ")); },
        q = window.location.hash.substring(1);

    while (e = r.exec(q))
        hashParams[d(e[1])] = d(e[2]);

    return hashParams;
}


function getBaseUrl() {
    return window.location.origin + window.location.pathname;
}

export { getHashParams, getBaseUrl };